import React from 'react';

import { ReactFCV } from '@types';

import { StyledServiceItemContainer, StyledSkeleton } from './styled';

export const ServiceItem: ReactFCV = () => (
  <StyledServiceItemContainer>
    <StyledSkeleton width={8} />
    <StyledSkeleton width={3} />
  </StyledServiceItemContainer>
);
